// Svelte 5 no longer needs svelte/store imports for basic reactivity
import platform from 'platform-detect';
import online from "../configs/status.js";

// Create reactive state for environment information
// Using $state with a readonly pattern since this was previously a readable store
export const environment = $state({
  desktop: platform.node,
  browser: platform.website,
  web: platform.web,
  electron: platform.packaged,
  mac: platform.macos,
  windows: platform.windows,
  linux: platform.linux,
  version: "1.8.51",
  system: "tv2", //demo or customer name (e.g. tv2, adapt, xr, gv, dvw, unity, converter, or ateliere)
  // Parent origins allowed to embed this build. Empty or ["*"] = unrestricted (demo).
  allowedParentOrigins: ["*"], // https://app.closedcaptionunity.com, https://app.closedcaptionconverter.com
  iframe: window.self !== window.top,
  adLicense: false,
  parentExportSubtitle: false,
  parentCancel: false,
  online: online
});